import { Component, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import { OfferteServiceService } from './service/offerte-service.service';
import { Offerte } from './model/offerte';
import { OfferteMinComponent } from './offerte-min/offerte-min.component';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CookieLawModule } from 'angular2-cookie-law';
import { LeadserviceService } from './service/leadservice.service';
declare var ga: Function;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})


export class AppComponent implements OnInit {
  title = 'che bello';


  @ViewChild('cookieLaw')
  private cookieLawEl: any;
  // private cookieLawSeen: boolean;
  private sub: any;
  public viewMenu: string;
  public dismiss(): void {
    this.cookieLawEl.dismiss();
  }

  ngOnInit() {
    // this.cookieLawSeen = this.cookieLawEl.cookieLawSeen;

    this.viewMenu = "1";


    this.route.queryParams.subscribe(params => {
      console.log(params);
      let iddem = params.iddem;
      if (iddem == null || iddem === 0) { iddem = 50; } else {
        this.servicelead.setIddem(iddem);
      }

      if (this.servicelead.getIddem() == null) { this.servicelead.setIddem(iddem); }



    });




  }

  // tslint:disable-next-line:max-line-length
  constructor(private router: Router, private servicelead: LeadserviceService, private route: ActivatedRoute, private elementRef: ElementRef) {


    router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        if (event.url.includes("Landing")) {
        this.viewMenu = "0";
        }
        else {
          this.viewMenu = "1";
        }
        window.scroll(0, 0);
        console.log('iddem service ' + this.servicelead.getIddem());
        try {
          if (typeof ga === 'function') {
            ga('set', 'page', event.urlAfterRedirects);
            ga('send', 'pageview');
            // console.log("%%% Google Analytics page view event %%%"+event.urlAfterRedirects);
          } else {
            console.log('ga not function');
          }
        } catch (e) {
          console.log('Errore ga ' + e);
        }
      });

  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts